import { render, staticRenderFns } from "./emailTextElementEditor.vue?vue&type=template&id=7a5c708c&scoped=true&"
import script from "./emailTextElementEditor.vue?vue&type=script&lang=js&"
export * from "./emailTextElementEditor.vue?vue&type=script&lang=js&"
import style0 from "./emailTextElementEditor.vue?vue&type=style&index=0&id=7a5c708c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5c708c",
  null
  
)

export default component.exports